<template><div><h1 id="kantone" tabindex="-1"><a class="header-anchor" href="#kantone"><span>Kantone</span></a></h1>
<p>Kantone — Verzeichnis gültiger Kantone</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle definiert die im System gültigen Kantone und dient der Validierung von Eingaben bei der Adresse. Sie kann vom Kunden manuell gepflegt werden.</p>
<p>Pfad: <code v-pre>Datenaustausch → Tabellen → Postdaten → Kantone</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Kanton</dt>
<dd>Kürzel für Kanton, 2-stellig, alphanumerisch</dd>
<dt>Kantonsname</dt>
<dd>Bezeichnung des Kantons</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/postdaten_verarbeiten.html" title="5. Post-Daten verarbeiten">Postdaten verarbeiten</RouteLink></p>
</div></template>


